/**
 * @ngdoc function
 * @name lmApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmApp
 */
lmApp.controller('RegisterController', ['$scope', '$rootScope', '$location', '$routeParams', '$timeout', '$interval', 'RegistrationService', 'ValidatorService', 'ApiService', 'vcRecaptchaService',
  function ($scope, $rootScope, $location, $routeParams, $timeout, $interval, RegistrationService, ValidatorService, ApiService, vcRecaptchaService) {
    $scope.regEzp = /^[0-9a-z-_]{3,20}$/;
    $scope.translit = translit;

    $scope.setResponse = function (response) {
      $scope.registrationFormData.inputs.recaptchaResponse = response;
      $scope.registrationFormData.validation.errors.recaptcha = $scope.registrationFormData.validation.recaptcha();
    };

    $scope.setWidgetId = function (widgetId) {
      $timeout(function () {
        $scope.widgetId = widgetId;
      }, 1000);
    };

    $scope.cbExpiration = function () {
      vcRecaptchaService.reload($scope.widgetId);
      $scope.registrationFormData.inputs.recaptchaResponse = null;
    };

    $scope.registrationFormData = {
      loading: false,
      isRegistrationComplete: false,
      inputs: {
        name: '',
        firstName: '',
        lastName: '',
        company: '',
        country: '',
        email: '',
        password1: '',
        password2: '',
        recaptchaResponse: null,
        invite: ''
      },

      validation: {
        errorPass: '',
        errorConfirm: '',
        ready: function () {
          return $scope.registrationFormData.inputs.name && !this.name() && !this.errors.name &&
            $scope.registrationFormData.inputs.email && !this.email() && !this.errors.email &&
            $scope.registrationFormData.inputs.password1 && !this.checkPassLength() && !this.errors.pass1 &&
            $scope.registrationFormData.inputs.password2 && !this.checkPass2() && !this.errors.pass2 &&
            $scope.registrationFormData.inputs.firstName && !this.firstName() && !this.errors.firstName &&
            $scope.registrationFormData.inputs.lastName && !this.lastName() && !this.errors.lastName &&
            $scope.registrationFormData.inputs.company && !this.company() && !this.errors.company &&
            $scope.registrationFormData.inputs.country && !this.country() && !this.errors.country &&
            $scope.registrationFormData.inputs.invite && !this.invite() && !this.errors.invite &&
            $scope.registrationFormData.inputs.recaptchaResponse && !this.recaptcha() && !this.errors.recaptchaResponse;
        },

        email: function () {
          if (!$scope.registrationFormData.inputs.email.length) {
            $scope.registrationFormData.validation.errorEmail = 'Empty Email';
            return true;
          }

          if ($scope.registrationFormData.inputs.email.length && !ValidatorService.Email($scope.registrationFormData.inputs.email)) {
            $scope.registrationFormData.validation.errorEmail = 'Wrong Email format';
            return true;
          }
        },

        emailIsExist: function () {
          if (!$scope.registrationFormData.inputs.email) return;

          if ($scope.IntEmail) $timeout.cancel($scope.IntEmail);

          $scope.IntEmail = $timeout(function () {
            if ($scope.emailCheckInProgress) return;

            $scope.emailCheckInProgress = true;
            var url = '1/operator/exists?email=' + $scope.registrationFormData.inputs.email;
            ApiService.Request(url, 'GET')
              .then(function (response) {
                $scope.emailCheckInProgress = false;
                if (response.exists) {
                  $scope.registrationFormData.validation.errorEmail = 'Sorry. Already exist';
                  $scope.registrationFormData.validation.errors.email = true;
                }
              })
              .catch(function () {
                $scope.emailCheckInProgress = false;
              })
          }, 250);
        },

        checkPassLength: function () {
          if (!$scope.registrationFormData.inputs.password1.length) {
            $scope.registrationFormData.validation.errorPass = 'Empty Password';
            return true;
          }

          if ($scope.registrationFormData.inputs.password1 && $scope.registrationFormData.inputs.password1.length < 6) {
            this.errorPass = 'Password minimum length 6';
            return true;
          }
        },

        checkPass2: function () {
          if (!this.checkPassLength() &&
            $scope.registrationFormData.inputs.password2 &&
            $scope.registrationFormData.inputs.password1 !== $scope.registrationFormData.inputs.password2) {
            this.errorConfirm = 'Password does not match';
            return true;
          }
        },

        name: function () {
          if (!$scope.registrationFormData.inputs.name || !$scope.regEzp.test(translit($scope.registrationFormData.inputs.name.toLowerCase()))) {
            this.errorName = 'Min length 3, max 20. Only Latin letters, numbers, -, _';
            return true;
          }
        },

        nameIsExist: function () {
          if (!$scope.registrationFormData.inputs.name) return;

          if ($scope.IntName) $timeout.cancel($scope.IntName);

          $scope.IntName = $timeout(function () {
            if ($scope.nameCheckInProgress) return;

            $scope.nameCheckInProgress = true;
            var url = '1/operator/exists?name=' + translit($scope.registrationFormData.inputs.name);
            ApiService.Request(url, 'GET')
              .then(function (response) {
                $scope.nameCheckInProgress = false;
                if (response.exists) {
                  $scope.registrationFormData.validation.errorName = 'Sorry. Already exist';
                  $scope.registrationFormData.validation.errors.name = true;
                }
              })
              .catch(function () {
                $scope.nameCheckInProgress = false;
              })
          }, 250);
        },

        firstName: function () {
          if (!$scope.registrationFormData.inputs.firstName) {
            this.errorFirstName = 'Leave your contact information so we can contact you';
            return true;
          }
        },

        lastName: function () {
          if (!$scope.registrationFormData.inputs.lastName) {
            this.errorLastName = 'Leave your contact information so we can contact you';
            return true;
          }
        },

        company: function () {
          if (!$scope.registrationFormData.inputs.company) {
            this.errorCountry = 'Required field';
            return true;
          }
        },

        country: function () {
          if (!$scope.registrationFormData.inputs.country) {
            this.errorCompany = 'Required field';
            return true;
          }
        },

        recaptcha: function () {
          if (_.isUndefined($scope.widgetId) || !$scope.registrationFormData.inputs.recaptchaResponse) {
            this.errorRecaptchaResponse = 'Wrong reCaptcha';
            return true;
          }
        },

        invite: function () {
          if (!$scope.registrationFormData.inputs.invite) {
            this.errorInvite = 'Required field';
            return true;
          }
        },

        errors: {}
      },

      register: function () {
        if (this.loading) return;
        if (!this.validation.ready()) {
          $scope.registrationFormData.validation.nameIsExist();
          $scope.registrationFormData.validation.emailIsExist();
          $scope.registrationFormData.validation.errors.name = $scope.registrationFormData.validation.name();
          $scope.registrationFormData.validation.errors.firstName = $scope.registrationFormData.validation.firstName();
          $scope.registrationFormData.validation.errors.lastName = $scope.registrationFormData.validation.lastName();
          $scope.registrationFormData.validation.errors.company = $scope.registrationFormData.validation.company();
          $scope.registrationFormData.validation.errors.country = $scope.registrationFormData.validation.country();
          $scope.registrationFormData.validation.errors.email = $scope.registrationFormData.validation.email();
          $scope.registrationFormData.validation.errors.pass1 = $scope.registrationFormData.validation.checkPassLength();
          $scope.registrationFormData.validation.errors.pass2 = $scope.registrationFormData.validation.checkPass2();
          $scope.registrationFormData.validation.errors.recaptcha = $scope.registrationFormData.validation.recaptcha();
          $scope.registrationFormData.validation.errors.invite = $scope.registrationFormData.validation.invite();
          return;
        }

        this.error = '';
        this.loading = true;
        $rootScope.showLinearProgress('#registerLoader');

        RegistrationService.Register($scope.registrationFormData.inputs)
          .then(function () {
            $scope.registrationFormData.isRegistrationComplete = true;
            $scope.registrationFormData.error = '';
            $scope.registrationFormData.loading = false;
            $rootScope.hideLinearProgress('#registerLoader');

          }, function (reason) {
            $scope.registrationFormData.loading = false;
            $rootScope.hideLinearProgress('#registerLoader');

            if (reason.message) {
              switch (reason.message) {
                case 'operator with this ext_id already exist':
                  $scope.registrationFormData.error = 'This EMAIL has been already registered in the system';
                  break;

                case 'operator already exists':
                  $scope.registrationFormData.error = 'This Project name already exists in the system';
                  break;

                case 'invalid email':
                  $scope.registrationFormData.error = 'Invalid email address';
                  break;

                case 'invalid email format':
                  $scope.registrationFormData.error = 'Incorrect Email format';
                  break;

                case 'invalid password':
                  $scope.registrationFormData.error = 'Invalid characters in password';
                  break;

                case 'invalid recaptcha':
                  $scope.registrationFormData.error = 'Invalid reCaptcha';

                  break;

                case 'invalid invite code':
                  $scope.registrationFormData.error = 'Invalid activation code';
                  $scope.registrationFormData.validation.errors.invite = 'Invalid activation code';
                  break;

                default:
                  $rootScope.debugInfo(reason);
                  break;
              }

              if (!_.isUndefined($scope.widgetId)) {
                vcRecaptchaService.reload($scope.widgetId);
              }
            } else {
              $rootScope.debugInfo(reason);
            }
          });
      },

      error: ''
    };

    $scope.watcher = $scope.$watchCollection('registrationFormData.inputs', function (newValue, oldValue) {
      if (newValue.name !== oldValue.name) {
        $scope.registrationFormData.validation.errors.name = $scope.registrationFormData.validation.name();
        $scope.registrationFormData.validation.nameIsExist();
      }
      if (newValue.firstName !== oldValue.firstName) {
        $scope.registrationFormData.validation.errors.firstName = $scope.registrationFormData.validation.firstName();
      }
      if (newValue.lastName !== oldValue.lastName) {
        $scope.registrationFormData.validation.errors.lastName = $scope.registrationFormData.validation.lastName();
      }
      if (newValue.company !== oldValue.company) {
        $scope.registrationFormData.validation.errors.company = $scope.registrationFormData.validation.company();
      }
      if (newValue.country !== oldValue.country) {
        $scope.registrationFormData.validation.errors.country = $scope.registrationFormData.validation.country();
      }
      if (newValue.email !== oldValue.email) {
        $scope.registrationFormData.validation.errors.email = $scope.registrationFormData.validation.email();
        $scope.registrationFormData.validation.emailIsExist();
      }
      if (newValue.password1 !== oldValue.password1) {
        $scope.registrationFormData.validation.errors.pass1 = $scope.registrationFormData.validation.checkPassLength();
      }
      if (newValue.password2 !== oldValue.password2) {
        $scope.registrationFormData.validation.errors.pass2 = $scope.registrationFormData.validation.checkPass2();
      }
    });

    $timeout(function () {
      $scope.recaptchaReady = true;
    }, 1000);

    $scope.$on('$destroy', function () {
      if ($scope.intPreloadSmall) $interval.cancel($scope.intPreloadSmall);
      if ($scope.intPreload) $interval.cancel($scope.intPreload);
      $scope.watcher();
    });

  }]);
